<template>
	<ValidationObserver v-slot="{ handleSubmit }" ref="orderCollectionOfFeesFormObserver" tag="div">
		<form :class="{ 'is-waiting': isWaiting }" @submit.prevent="handleSubmit(putPayAgreement)" class="agreement-item">
			<b class="agreement-name">Umowa za zawody: {{ agreement.name }}</b>

			<div class="agreement-date">
				<base-button
					btn9
					icon="dsi dsi-download"
					@click="payAgreementLink(agreement.id)"
				>
					<span>Pobierz wzór umowy</span>
				</base-button>
			</div>
			<div class="agreement-actions">
				<ValidationProvider name="file" rules="required" v-slot="{ errors }" class="scroll-margin">
					<base-input-file
						v-model="file"
						accept="image/*,.pdf"
						:isMultiple="false"
						converter="base64"
						hint="Wybierz plik"
						:class="{
							'is-error':  errors[0]
						}"
					/>
					<span v-if="errors[0]" class="input-error-alt">Pole wymagane</span>
				</ValidationProvider>
				<base-button @click="handleSubmit(putPayAgreement)" btn1 short>
					<span>AKCEPTUJĘ</span>
				</base-button>
			</div>
		</form>
	</ValidationObserver>
</template>

<script>
import api from '@/api';
import { API_ADDRESS } from '@/config';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'required_field'
})

export default {
	name: 'PanelAdminPayAgreements',
	props: {
        id: {
            type: Number,
           required: true,
        },
		agreement: {
			type: Object,
			required: true,
			default: () => ({})
		},
	},
	components: {
		ValidationObserver,
		ValidationProvider
	},
	data() {
		return {
			file: [],
			isWaiting: false,
		}
	},
	computed: {},
	created() {},
	methods: {
		payAgreementLink(id) {
			window.open(`${API_ADDRESS}/agreement/${id}/pay-competition`, '_blank');
		},
		async putPayAgreement() {
			try {
				this.isWaiting = true;
				await api.post(`/panel/competitions/${this.id}/files/payAgreement`, this.file[0])
				this.$emit('update');
			} catch (error) {
				console.error(error);
			} finally {
				this.isWaiting = false;
			}
		}
	}
}
</script>

<style scoped>
.agreement-item {
	border-radius: 4px;
	background-color: var(--color-white, #fff);
    color: var(--color-charcoal-grey-two, #37474f);
	display: flex;
    align-items: center;
    padding: 16px;
	flex-wrap: wrap;
	gap: 8px;
}

.agreement-name {
	width: 55%;
}

.agreement-date {
	margin-left: auto;
}

.agreement-actions {
	width: 100%;
	display: flex;
	gap: 8px;
}

.scroll-margin {
	width: 100%;
}

.input-error-alt {
	display: block;
	color: var(---color-pinky-red, red);
	font-size: 12px;
	margin-top: 4px;
}
</style>	
